// extracted by mini-css-extract-plugin
module.exports = {"myAccountPrivacyFormCard":"MyAccountPrivacyFormCard_myAccountPrivacyFormCard__0sc1Q","rotation":"MyAccountPrivacyFormCard_rotation__sEttQ"};